import * as React from "react";
import { FontIcon, FontSizes, FontWeights, getTheme, IStackItemStyles, IStackTokens, mergeStyles, Stack, Text } from "@fluentui/react";

interface SectionTitleProps {
  title: string;
  isExpanded: boolean;
  toggleIsExpanded: () => void;
}

const theme = getTheme();

const containerStackTokens: IStackTokens = { childrenGap: 10 };

const iconClass = mergeStyles({
  color: theme.palette.neutralPrimary,
  // fontSize: 16
});

const textRegular = mergeStyles({
  color: theme.palette.neutralPrimary,
  fontSize: FontSizes.size18,
  fontWeight: FontWeights.regular,
});

const SectionTitle: React.FunctionComponent<SectionTitleProps> = ({
  title,
  isExpanded,
  toggleIsExpanded
}: SectionTitleProps) => {
  return (
    <Stack className="xb-subtitle-container" horizontal={true} verticalAlign="center" tokens={containerStackTokens} onClick={toggleIsExpanded}>
      <FontIcon iconName={isExpanded ? "ChevronDown" : "ChevronRight"} className={iconClass} />
      <Text className={textRegular}>{title}</Text>
    </Stack>
  );
};
export default SectionTitle;
